import { careersTransitionName, cssIdent, newsTransitionName } from "@lib/view-transitions"
import type { CareerItem, NewsItem } from "@site-types/content"

type AstroNewsViewTransitionsProps = {
  news: NewsItem[]
}

type AstroCareersViewTransitionsProps = {
  careers: CareerItem[]
}

const astroTransitionRule = (name: string) => {
  const ident = cssIdent(name)
  return `
html:active-view-transition-type(${ident})::view-transition-old(${ident}) {
  animation-duration: 180ms;
  animation-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
  animation-fill-mode: both;
  animation-name: astroFadeOut;
}

html:active-view-transition-type(${ident})::view-transition-new(${ident}) {
  animation-duration: 180ms;
  animation-timing-function: cubic-bezier(0.76, 0, 0.24, 1);
  animation-fill-mode: both;
  animation-name: astroFadeIn;
}
`
}

export function AstroNewsViewTransitions({ news }: AstroNewsViewTransitionsProps) {
  const transitionNames = [
    ...new Set(
      news
        .map((post) => post.slug?.current)
        .filter((slug): slug is string => !!slug)
        .map(newsTransitionName)
    ),
  ]

  if (transitionNames.length === 0) return null

  return (
    <style data-testid="astro-news-view-transitions">
      {transitionNames.map(astroTransitionRule).join("\n")}
    </style>
  )
}

export function AstroCareersViewTransitions({ careers }: AstroCareersViewTransitionsProps) {
  const transitionNames = [
    ...new Set(
      careers
        .map((position) => position.slug?.current)
        .filter((slug): slug is string => !!slug)
        .map(careersTransitionName)
    ),
  ]

  if (transitionNames.length === 0) return null

  return (
    <style data-testid="astro-careers-view-transitions">
      {transitionNames.map(astroTransitionRule).join("\n")}
    </style>
  )
}
